export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage': 'umi ui is now released, welcome to use npm run ui to start the experience.',

  'pages.common.createDate': 'Create time',
  'pages.common.id': 'ID',
  'pages.common.createUserName': 'Created by',
  'pages.common.lastUpdDate': 'Update time',
  'pages.common.lastUpdUserName': 'Updated by',
  'pages.common.option': 'Operation',
  'pages.common.create': 'New',
  'pages.common.apply': 'Apply',
  'pages.common.edit': 'Edit',
  'pages.common.delete': 'Delete',
  'pages.common.restore': 'Restore',
  'pages.common.copy': 'Clone',
  'pages.common.status': 'Status',
  'pages.common.share': 'Share',
  'pages.common.tag': 'Tag',
  'pages.common.productManagerName': 'Product Manager',
  'pages.common.uiDesignName': 'UI Design',
  'pages.common.developName': 'Backend Development',
  'pages.common.frontWebName': 'Front-end Development',
  'pages.common.testEngineerName': 'Test Development',
  'pages.common.testName': 'Test',
  'pages.common.itSupportName': 'Technical Support',
  'pages.common.businessCounterpartName': 'Business counterpart',
  'pages.common.form.selectProduct': 'Please select product manager',
  'pages.common.form.selectBusinessCounterpartName': 'Please select business counterpart',
  'pages.common.form.selectUdDesign': 'Please select UI design',
  'pages.common.form.selectDev': 'Please select backend development',
  'pages.common.form.selectFont': 'Please select front-end development',
  'pages.common.form.selectTest': 'Please select test development',
  'pages.common.form.selectSupport': 'Please select technical support',
  'pages.common.startTime': 'Start time',
  'pages.common.endTime': 'End time',
  'pages.common.colSetting': 'Column settings',
  'pages.common.closed': 'Archived',
  'pages.common.filter': 'Filter',
  'pages.common.clear': 'Clear',
  'pages.common.notarize': 'Confirm',
  'pages.common.addRemark': 'Add remark',
  'pages.common.assign': 'Assign handler',
  'pages.common.cardUnit': 'pcs',

  'pages.business.businessNameCn': 'Business Area (CN)',
  'pages.business.businessNameEn': 'Business Area (EN)',
  'pages.business.systemId': 'Related System',
  'pages.business.title': 'Business Area',

  'pages.system.updateForm.schedulingPeriod.timeLabel': 'Start time',
  'pages.system.updateForm.schedulingPeriod.timeRules': 'Please select a start time! ',
  'pages.system.status': 'Enable Status',
  'pages.system.title': 'System',
  'pages.system.name': 'System Name',
  'pages.system.systemId': 'System ID (associated with Jira SystemId)',
  'pages.system.systemKey': 'System Key',
  'pages.system.ruleName': 'System name is required',
  'pages.system.businessName': 'Business Area',
  'pages.system.businessNameEn': 'Business Area - English',
  'pages.system.leaderUserName': 'System Leader',
  'pages.system.businessLeaderUserName': 'Business Area Leader',
  'pages.system.businessUserCount': 'Business Participants Count',
  'pages.system.systemDesc': 'System Description',
  'pages.system.exception': 'Please enter the reason for the exception! ',
  'pages.system.form.businessName': 'Business Area',
  'pages.system.form.systemKey': 'System Key (unique)',
  'pages.system.form.selectBusiness': 'Please select a business area',
  'pages.system.form.selectSystemLeader': 'Please select system leader',
  'pages.system.form.inputSystemName': 'Please enter system name',
  'pages.system.form.inputSystemId': 'Please enter associated Jira system ID',
  'pages.system.form.inputSystemKey': 'Please enter system Key',
  'pages.system.form.robotId': 'Robot ID',

  'pages.businessIssue.productManagerName': 'Product Contact',
  'pages.businessIssue.productManagerName2': 'Contact',
  'pages.businessIssue.businessSideInfo': 'Proposer',
  'pages.businessIssue.businessRelatedInfo': 'Related Person',
  'pages.businessIssue.pengingTime': 'Waiting Duration (Days)',
  'pages.businessIssue.pengingTime2': 'Waiting Duration',
  'pages.businessIssue.expectDate': 'Expected Completion Time',
  'pages.businessIssue.relatedIssues': 'Related Product Requirements',
  'pages.businessIssue.relatedIssuesCount': 'Related Product Requirements Count',
  'pages.businessIssue.createProductIssue': 'Create Product Requirement',

  'pages.issuePool.issueId': 'Serial Number',
  'pages.issuePool.issueName': 'Requirement Name',
  'pages.issuePool.system': 'System',
  'pages.issuePool.relatedUser': 'Related Person (CC)',
  'pages.issuePool.complexRate': 'Complexity',
  'pages.issuePool.sourceDesc': 'Requirement Source',
  'pages.issuePool.country': 'Country',
  'pages.issuePool.label': 'Label',
  'pages.issuePool.priorityLevel': 'Priority',
  'pages.issuePool.sprint': 'Sprint',
  'pages.issuePool.expectDate': 'Expected Completion Time',
  'pages.issuePool.completeDate': 'Actual Completion Time',
  'pages.issuePool.expectDate2': 'Expected Completion',
  'pages.issuePool.completeDate2': 'Actual Completion',
  'pages.issuePool.reviewDate': 'Review (Meeting) Time',
  'pages.issuePool.allReviewDate': 'Time',
  'pages.issuePool.relatedIssues': 'Related Requirements',
  'pages.issuePool.follower': 'Follow',
  'pages.issuePool.cancelFollower': 'Unfollow',
  'pages.issuePool.transfer': 'Transfer System',
  'pages.issuePool.planName': 'Plan Name',
  'pages.issuePool.allIssues': 'All Requirements',
  'pages.issuePool.currentSprint': 'View Current Sprint',
  'pages.issuePool.taskCnt': 'Task Count',
  'pages.issuePool.release': 'Create Release Order',
  'pages.issuePool.isTechnical': 'Technical Requirement',
  'pages.issuePool.isRequireTrainer': 'Requires System Training',
  'pages.issuePool.addPlan': 'Bind Requirement to Sprint (default shows Sprint of requirement system)',
  'pages.issuePool.follewUsers': 'Followers',
  'pages.issuePool.taskTotalTime': 'Total Task Time',
  'pages.issuePool.taskTime': 'Task Time',
  'pages.issuePool.form.selectIssueName': 'Please enter title',
  'pages.issuePool.form.selectExpectDate': 'Please select expected date',
  'pages.issuePool.form.selectComplexRate': 'Please select complexity',
  'pages.issuePool.form.selectPriorityLevel': 'Please select priority',
  'pages.issuePool.form.estimatedPersonDay': 'Estimated Person Days',
  'pages.issuePool.form.businessReviewName': 'Business Review Name',
  'pages.issuePool.form.collaborativeIssue': 'Collaborative Requirement',
  'pages.issuePool.form.relatedSprint': 'Related Sprint',
  'pages.issuePool.form.country': 'Requirement Impact Country',
  'pages.issuePool.form.isRequireTrainer': 'Whether System Training is Required',

  'pages.release.collaboratorList': 'Collaborators',
  'pages.release.Date': 'Release Date',

  'pages.issueReview.name': 'Review (Meeting) Name',
  'pages.issueReview.allName': 'Name',
  'pages.issueReview.createUserName': 'Initiator',
  'pages.issueReview.reviewUsers': 'Review (Meeting) Participants',
  'pages.issueReview.status': 'Review (Meeting) Status',
  'pages.issueReview.reviewType': 'Review (Meeting) Type',
  'pages.issueReview.reviewReadCount': 'Confirmation Status',
  'pages.issueReview.reviewTime': 'Estimated Review Time',
  'pages.issueReview.relatedIssueCount': 'Related Requirements Count',
  'pages.issueReview.meetingCount': 'Meeting Count',
  'pages.issueReview.meetingCode': 'Click to Copy Meeting Code',
  'pages.issueReview.createMeeting': 'Initiate Meeting',
  'pages.issueReview.editMeeting': 'Edit Meeting',
  'pages.issueReview.cancelMeeting': 'Cancel Meeting',
  'pages.issueReview.cancelReview': 'Delete Review',
  'pages.issueReview.ReviewAgain': 'Review Again',
  'pages.issueReview.reviewDesc': 'Review (Meeting) Description',
  'pages.issueReview.form.meetingName': 'Review Meeting Name',
  'pages.issueReview.form.allMeetingName': 'Meeting Name',
  'pages.issueReview.form.meetingTime': 'Meeting Duration',
  'pages.issueReview.form.reviewMeetingDesc': 'Review Meeting Description',
  'pages.issueReview.form.allReviewMeetingDesc': 'Meeting Description',
  'pages.issueReview.form.plan': 'Plan',
  'pages.issueReview.form.issues': 'Requirement',
  'pages.issueReview.form.reviewMeetingContent': 'Review Meeting Minutes',
  'pages.issueReview.issuePool.unReadCount': 'Unread Count',
  'pages.issueReview.issuePool.unReadUser': 'Unread Users',
  'pages.issueReview.issuePool.readCount': 'Read Count',
  'pages.issueReview.issuePool.readUser': 'Read Users',
  'pages.issueReview.meetingRemindBefores': 'Remind Before Start',

  'pages.sprint.name': 'Sprint Name',
  'pages.sprint.owner': 'Owner',
  'pages.sprint.goal': 'Sprint (Iteration) Goal',
  'pages.sprint.issueCnt': 'Requirement Count',
  'pages.sprint.cycle': 'Cycle (GMT+8)',
  'pages.sprint.budget': 'Person Day Budget (Day)',
  'pages.sprint.isSynergy': 'Collaborative Planning',
  'pages.sprint.plan': 'Sprint Planning',
  'pages.sprint.version': 'Version Number',
  'pages.sprint.createVersion': 'Create Iteration',
  'pages.sprint.form.time': 'Start - End',
  'pages.sprint.form.issues': 'Requirement',
  'pages.sprint.add.issue': 'Add Requirement',
  'pages.sprint.systemNames': 'System',

  'pages.task.id': 'Task ID',
  'pages.task.name': 'Task Name',
  'pages.task.type': 'Type',
  'pages.task.complexRate': 'Complexity',
  'pages.task.priorityLevel': 'Priority',
  'pages.task.status': 'Status',
  'pages.task.owner': 'Owner',
  'pages.task.taskParticipants': 'Participants',
  'pages.task.task': 'Task Detail List',
  'pages.task.estimatedPersonDay': 'Estimated Person Days',
  'pages.task.issues': 'Requirement',
  'pages.task.serviceType': 'Service Type',
  'pages.task.service': 'Service',
  'pages.task.branch': 'Branch',
  'pages.task.overtime': 'Overdue',
  'pages.task.form.time': 'Start - End',
  'pages.task.sprint': 'Iteration',

  'pages.test.caseName': 'Case Name',
  'pages.test.systemName': 'System',
  'pages.test.issueName': 'Requirement',
  'pages.test.moduleName': 'Module',
  'pages.test.caseLevel': 'Case Level',
  'pages.test.reviewStatusDesc': 'Review Status',
  'pages.test.fileName': 'File Name',

  'pages.bug.title': 'Title',
  'pages.bug.system': 'System',
  'pages.bug.issue': 'Requirement',
  'pages.bug.severityLevel': 'Severity Level',
  'pages.bug.priorityLevel': 'Priority',
  'pages.bug.implementationPlan': 'Implementation Plan',
  'pages.bug.bugType': 'Bug Type',
  'pages.bug.proposer': 'Reporter',
  'pages.bug.assignedUser': 'Assigned To',
  'pages.bug.assignedDate': 'Assigned Time',
  'pages.bug.relatedIssueInfos': 'Related Requirements',
  'pages.bug.deadline': 'Deadline',
  'pages.bug.relatedIssuesCount': 'Related Product Requirements Count',
  'pages.bug.bugPageUrlsCnt': 'Bug Page URLs Count',
  'pages.bug.responseTime': 'Response Time',
  'pages.bug.processingTime': 'Processing Time',
  'pages.bug.waitingCloseTime': 'Waiting to Close',
  'pages.bug.waitingTime': 'Total Time',
  'pages.bug.carbonCopyUser': 'CC',
  'pages.bug.operatingSystem': 'Operating System',
  'pages.bug.resolvedUser': 'Resolver',
  'pages.bug.confirmedDate': 'Confirmed Time',
  'pages.bug.resolvedDate': 'Resolved Time',
  'pages.bug.closedUser': 'Closer',
  'pages.bug.closedDate': 'Closed Time',
  'pages.bug.confirm': 'Confirm',
  'pages.bug.resolve': 'Resolve',
  'pages.bug.reopen': 'Reopen',
  'pages.bug.closed': 'Closed',
  'pages.bug.reminder': 'Reminder',
  'pages.bug.clone': 'Clone',
  'pages.bug.join': 'Join Group',

  'pages.codeQuality.title': 'Project/Service',
  'pages.codeQuality.type': 'Category',
  'pages.codeQuality.lines': 'Total Lines of Code',
  'pages.codeQuality.changeLines': 'Code Lines Change',
  'pages.codeQuality.addLines': 'Incremental Code Lines',
  'pages.codeQuality.allLines': 'Total Lines of Code',
  'pages.codeQuality.bugs': 'Defect Count',
  'pages.codeQuality.bugDensity': 'Defect Rate per 1000 Lines (‰)',
  'pages.codeQuality.addBugDensity': 'Incremental Code Defect Rate (%)',
  'pages.codeQuality.allBugDensity': 'Total Defect Rate per 1000 Lines (‰)',

  'pages.efficiencyDashboard.title': 'Requirement Delivery Overview',
  'pages.efficiencyDashboard.issueStatistics': 'Requirement Stock Statistics',
  'pages.efficiencyDashboard.stockCount': 'Total Stock',
  'pages.efficiencyDashboard.pendingInterventionsCount': 'Pending Intervention',
  'pages.efficiencyDashboard.suspendedCount': 'Suspended',
  'pages.efficiencyDashboard.underSolutionCount': 'In Solution',
  'pages.efficiencyDashboard.toBeDevelopedCount': 'To Be Developed',
  'pages.efficiencyDashboard.underDevelopmentCount': 'Under Development',
  'pages.efficiencyDashboard.recentSevenDayDasboard': 'Recent 7 Days Requirement Overview',
  'pages.efficiencyDashboard.newCount': 'New',
  'pages.efficiencyDashboard.closeCount': 'Closed',
  'pages.efficiencyDashboard.totalReleaseCount': 'Total Releases',
  'pages.efficiencyDashboard.normalReleaseCount': 'Normal Releases',
  'pages.efficiencyDashboard.emergencyReleaseCount': 'Emergency Releases',
  'pages.efficiencyDashboard.delayedUnpublishedCount': 'Delayed Unpublished',
  'pages.efficiencyDashboard.recentSevenDayQuality': 'Recent 7 Days Requirement Quality',
  'pages.efficiencyDashboard.handledWaitTime': 'Requirement Wait Time (Handled) Unit: hours',
  'pages.efficiencyDashboard.designTime': 'Requirement Design Time (Handled) Unit: hours',
  'pages.efficiencyDashboard.recentSevenDayOption': 'Recent 7 Days Operations',
  'pages.efficiencyDashboard.changeCount': 'Status Change Count',

  // polarDB logs
  'pages.polarDB.log.id': 'ID',
  'pages.polarDB.log.environment': 'Environment',
  'pages.polarDB.log.dbClusterId': 'Cluster ID',
  'pages.polarDB.log.dbName': 'Database',
  'pages.polarDB.log.dbNodeId': 'Node ID',
  'pages.polarDB.log.executionStartTime': 'SQL Execution Time (UTC)',
  'pages.polarDB.log.hostAddress': 'Client Address',
  'pages.polarDB.log.lockTimes': 'SQL Lock Duration (seconds)',
  'pages.polarDB.log.queryTimes': 'SQL Execution Duration (seconds)',
  'pages.polarDB.log.parseRowCounts': 'Parse Row Count',
  'pages.polarDB.log.returnRowCounts': 'Return Row Count',
  'pages.polarDB.log.sqlText': 'Query Statement',
  'pages.polarDB.log.dataTimestamp': 'SQL Execution Timestamp',
  'pages.polarDB.log.sqlTemplateId': 'SQL Template ID',

  // polarDB template
  'pages.polarDB.tempalte.id': 'Template ID',
  'pages.polarDB.tempalte.environment': 'Environment',
  'pages.polarDB.tempalte.dbClusterId': 'Cluster ID',
  'pages.polarDB.tempalte.dbName': 'Database',
  'pages.polarDB.tempalte.dbNodeId': 'Node ID',
  'pages.polarDB.tempalte.hostAddress': 'Client Address',
  'pages.polarDB.tempalte.sqlText': 'SQL Template',
  'pages.polarDB.tempalte.createDate': 'Pull Time',
  'pages.polarDB.tempalte.lastUpdDate': 'Update Time',
  'pages.polarDB.tempalte.lastUpdUserName': 'Updated By',
  'pages.polarDB.tempalte.overdueDays': 'Overdue Days',
  'pages.polarDB.tempalte.handlerInfo': 'Handler',
  'pages.polarDB.tempalte.status': 'Processed',
  'pages.polarDB.tempalte.remark': 'Remark',

  // Database subscription
  'pages.db.subscribe.dbId': 'Database ID',
  'pages.db.subscribe.dbName': 'Database',
  'pages.db.subscribe.dbLeader': 'Leader',
  'is.subscribe': 'Subscribed',
  'subscribers': 'Subscribers',
  'pages.db.subscribe.explain':
    'Note: After subscribing to the database, starting from the next day, you will receive push notifications of slow SQL template data from yesterday for the subscribed database! (No push if there is no slow SQL)',
  'edit.subscribers': 'Edit Subscribers',

  // Labels
  'pages.label.status': 'Enable Status',
  'pages.label.type': 'Label Type',
  'pages.label.nameCn': 'Label Name (Chinese)',
  'pages.label.nameEn': 'Label Name (English)',
  'pages.label.markingCnt': 'Marking Count',
  'pages.label.lastUpdDate': 'Update Time',
  'pages.label.lastUpdUserName': 'Updated By',
  'pages.label.relationTypeName': 'Marking Type',
  'pages.label.relationName': 'Marking Name',
  'pages.label.createDate': 'Marking Time',
  'pages.label.createUserName': 'Marker',

  // Delivery
  'pages.delivery.id': 'ID',
  'pages.delivery.releaseCarrierId': 'Release Order ID',
  'pages.delivery.releaseCarrierName': 'Release Order Name',
  'pages.delivery.releaseCarrierType': 'Release Order Type',
  'pages.delivery.collaboratorInfos': 'Collaborators',
  'pages.delivery.otherInfo': 'Other Information',
  'pages.delivery.isEmergency': 'Emergency Release',
  'pages.delivery.progress': 'Status',
  'pages.delivery.progressDesc': 'Status',
  'pages.delivery.appointmentDate': 'Expected Release Date',
  'pages.delivery.releaseDate': 'Actual Release Date',
  'pages.delivery.checkTermList': 'Check Items',
  'pages.delivery.issueSn': 'Requirement Serial Number',
  'pages.delivery.taskCnt': 'Task Count',
  'pages.delivery.issueUrl': 'Requirement Details',
  'pages.delivery.serviceName': 'Service Name',
  'pages.delivery.serviceType': 'Service Type',
  'pages.delivery.serviceStatus': 'Pipeline Status',
  'pages.delivery.devOwnerNames': 'Dev Owner',
  'pages.delivery.developerNames': 'Developers',
  'pages.delivery.businessName': 'Business Area',
  'pages.delivery.serviceLevel': 'Service Level',
  'pages.delivery.serviceNature': 'Service Attribute',
  'pages.delivery.replicas': 'Container Replicas',
  'pages.delivery.branch': 'Development Branch',
  'pages.delivery.releaseNum': 'Release Count',
  'pages.delivery.emergencyReleaseNum': 'Emergency Count',
  'pages.delivery.updateBy': 'Latest Operator',
  'pages.delivery.updateTime': 'Latest Operation Time',

  'start.up.today': 'Production Deployment Today',
  'delivery.today': 'Delivery Today',
  'publish.window': 'Release Window',
  'service.publishing': 'Service Release',
  'release.reason': 'Release Reason',
  'code.branch': 'Code Branch',
  'oneClick.publishing': 'One-Click Release',
  'secondary.release': 'Secondary Release',
  'noLpt.publishing': 'Non-Production Release',
  'regression.completion': 'Regression Completed',
  'acceptance.pass': 'Acceptance Passed',
  'release.note': 'Release Notes',
  'requirement.acceptance.link': 'Requirement Acceptance Link',
  'release.history': 'Release History',
  'release.log': 'Release Log',
  'service.log': 'Service Log',
  'vulnerability.scanning': 'Vulnerability Scanning',
  publish: 'Publish',
  rollback: 'Rollback',
  'run.id': 'Run ID',
  branch: 'Branch',
  'commit.id': 'Commit ID',
  'run.time': 'Run Time',
  'opt.time': 'Operation Time',
  'end.time': 'End Time',
  'op.user': 'Operator',
  'finish.desc': 'Deployment Description',
  'please.select.a.branch': 'Please select a branch',
  'commit.publish': 'Commit Publish',
  'commit.scanner': 'Commit Scanner',
  'error.log': 'Error Log',
  'release.env': 'Release Environment',
  'product.requirements': 'Product Requirements',
  'pull.carrier.branch': 'Pull Release Order Branch',
  'refresh.branch': 'Refresh Branch',
  'related.items': 'Related Items',
  'whether.to.schedule.a.meeting': 'Whether to Schedule a Meeting',
  'review.issue': 'Review (Meeting) Requirement',
  'review.sprint': 'Review (Meeting) Sprint',
  'review.test.case': 'Review (Meeting) Test Cases',
  'meeting.code': 'Meeting Code',
  'edit.review': 'Edit Review',
  'edit.allReview': 'Edit',
  'complete.review': 'Complete Review',
  'initiate.a.review.meeting': 'Schedule Review Meeting',
  'initiate.a.allReview.meeting': 'Schedule Meeting',
  'update.review.meeting': 'Update Review Meeting',
  'update.review.allMeeting': 'Update Meeting',
  'fill.in.the.review.minutes': 'Fill in Meeting Minutes',
  'cancel.review.meeting': 'Cancel Review Meeting',
  'delete.review': 'Delete Review',
  'unconfirmed.person': 'Unconfirmed Person',
  'confirmed.person': 'Confirmed Person',
  'review.detail': 'Review Details',
  'relation.name': 'Related Name',
  'relation.type': 'Related Type',

  'create.dashboard': 'Create Dashboard',
  'pages.dashboard.kudoCard.description': 'Light up a star. Give instant kudos',
  'pages.dashboard.kudoCard.summary': 'Dear {nickname},you have received Starkudos from your colleague',
  'pages.dashboard.kudoCard.empty': 'No colleagues have given you Star Kudos yet~',
  'pages.dashboard.kudoRank.rankingRule': 'Ranking is calculated by total StarKudos collected.',
  'pages.dashboard.kudoRank.title': 'Star Kudos Rank Top 20',
  'pages.dashboard.kudoRank.yourRank': 'Your Rank',
  'pages.dashboard.kudoRank.rankTime': 'Rank Time: ',
  'pages.dashboard.kudoRank.noData': 'No ranking data',
  'pages.dashboard.kudoRank.selectGroup': 'Please select a card group',
  'pages.dashboard.receivedCards.title': 'Kudos Received',
  'pages.dashboard.receivedCards.description': 'Received This Event',
  'pages.dashboard.receivedCards.colleague': 'Colleague',
  'pages.dashboard.receivedCards.cardName': 'Star Kudos',
  'pages.dashboard.receivedCards.filter': 'Filter: ',
  'pages.dashboard.receivedCards.noCards': 'No Star Kudos',
  'pages.dashboard.myCards.title': 'StarKudos Inventory',
  'pages.dashboard.myCards.description': 'Available This Event',
  'pages.dashboard.myCards.available': 'Available',
  'pages.dashboard.myCards.status.pending': 'Pending',
  'pages.dashboard.myCards.status.used': 'Used',
  'pages.dashboard.myCards.filter': 'Filter: ',
  'pages.dashboard.myCards.noCards': 'No Cards',
  'instrument.name': 'Dashboard Name',
  'card.logo': 'Card Logo',
  'card.name.cn': 'Card Name (Chinese)',
  'card.name.en': 'Card Name (English)',
  'card.code': 'Card Code',
  'card.desc.cn': 'Card Description (Chinese)',
  'card.desc.en': 'Card Description (English)',
  'card.type': 'Card Type',
  'edit.personal.instrument.card': 'Edit Personal Dashboard Card',
  'card.list': 'Card List',
  'to.do.name': 'Todo Name',
  'to.do.type': 'Todo Type',
  'to.do.status': 'Todo Status',
  'expected.end': 'Expected Completion Time',
  'member.name': 'Member Name',
  'edit.members': 'Edit Members',
  'report.date': 'Report (Year-Week)',
  'weekly.report.title': 'Weekly Report Title',
  'weekly.report.type': 'Weekly Report Type',
  'weekly.report.title.template': 'Weekly Report Title Template',
  'weekly.report.content.template': 'Weekly Report Content Template',
  'report.to': 'Report To',
  'report.by': 'Reporter',
  'report.cc': 'CC',
  role: 'Role',
  'push.time': 'Send Time',
  'is.automatic.sending.enabled': 'Auto Send Enabled',
  'stage.name': 'Stage Name',
  quantity: 'Quantity',
  'week.on.month.ratio': 'Week-over-Week Ratio',
  'special.remark': 'Remark (Enter to save)',
  'read.count': 'Read Count',
  'add.comment': 'Add Comment',
  'comment.content': 'Comment Content',
  'chinese.name': 'Chinese Name',
  code: 'Code',
  'status.type': 'Status Type',
  'status.code': 'Status Code',
  'english.name': 'English Name',
  'status.group': 'Status Group',
  'echo.color': 'Display Color',
  'transferable.status': 'Transferable Status',
  sort: 'Sort',
  'clone.to.other.status.group': 'Clone to Other Status Group',
  'meeting.room.id': 'Meeting Room ID',
  'meeting.room.name': 'Meeting Room Name',
  'meeting.room.capacity': 'Meeting Room Capacity',
  city: 'City',
  building: 'Building',
  floor: 'Floor',
  'meeting.room.equipment': 'Meeting Room Equipment',
  sn: 'Serial Number',
  标题: 'Title',
  状态: 'Status',
  负责人: 'Owner',
  起始时间: 'Start Time',
  截止时间: 'End Time',
  创建时间: 'Create Time',
  创建人: 'Created By',
  工作项类型: 'Work Item Type',
  更新时间: 'Update Time',
  更新人名称: 'Updated By Name',
  操作: 'Operation',
  优先级: 'Priority',
  截止日期: 'Deadline',
  所属项目: 'Project',
  任务名称: 'Task Name',
  项目名称: 'Project Name',
  团队空间: 'Team Space',
  项目负责人: 'Project Owner',
  项目干系人: 'Project Stakeholders',
  项目周期: 'Project Cycle',
  默认视图: 'Default View',
  团队空间名称: 'Team Space Name',
  团队空间成员: 'Team Space Members',
  团队空间描述: 'Team Space Description',
  里程碑周期: 'Milestone Cycle',
  删除项目: 'Delete Project',
  项目是否公开: 'Is Project Public',
  编辑: 'Edit',
  新建需求: 'New Requirement',
  转产品需求: 'Convert to Product Requirement',
  新建任务: 'New Task',
  删除任务: 'Delete Task',
  里程碑负责人: 'Milestone Owner',
  需求名称: 'Requirement Name',
  所属系统: 'System',
  干系人: 'Stakeholders',
  描述: 'Description',
  需求周期: 'Requirement Cycle',
  项目参与人: 'Project Participants',
  项目创建人: 'Project Creator',
  项目创建时间: 'Project Create Time',
  里程碑名称: 'Milestone Name',
  里程碑: 'Milestone',
  系统: 'System',
  开始时间: 'Start Time',
  实际完成时间: 'Actual Completion Time',
  项目: 'Project',
  主产品经理: 'Main Product Manager',
  公开状态: 'Public Status',
  删除需求: 'Delete Requirement',
  删除里程碑: 'Delete Milestone',
  规划周期: 'Planning Cycle',
  人天预算: 'Person Day Budget',
  版本号: 'Version Number',
  关联需求任务数: 'Related Requirement Task Count',
  类型: 'Type',
  参与人: 'Participants',
  预估人天: 'Estimated Person Days',
  开始结束: 'Start - End',
  'commit.cnt': 'Commit Count',
  'merge.cnt': 'Merge Count',
  'push.cnt': 'Push Count',
  'tag.cnt': 'Tag Count',
  'merge.subscribe': 'Subscribe Merge',
  'push.subscribe': 'Subscribe Push',
  'merge.subscribers': 'Merge Subscribers',
  'push.subscribers': 'Push Subscribers',
  'warehouse.name': 'Repository Name',
  'related.sn': 'Related Serial Number',
  'commit.email': 'Commit Email',
  'commit.url': 'Commit URL',
  'commit.message': 'Commit Message',
  'commit.date': 'Commit Date',
  'commit.branch': 'Commit Branch',
  'git.http.url': 'Git Repository URL',
  'nick.name': 'Nickname',
  'attendance.date': 'Attendance Date',
  'attendance.type': 'Attendance Type',
  'attendance.start.address': 'Attendance Start Location',
  'attendance.end.address': 'Attendance End Location',
  'attendance.start.source': 'Attendance Start Source',
  'attendance.end.source': 'Attendance End Source',
  'attendance.start.result': 'Attendance Start Result',
  'attendance.end.result': 'Attendance End Result',
  'department.name': 'Department Name',
  'department.members': 'Department Members',
  'location.city': 'Base Location',
  'personal.attendance.days': 'Personal Attendance Days',
  'personal.total.working.hours': 'Personal Total Working Hours',
  'personal.average.working.hours': 'Personal Average Working Hours',
  'department.attendance.person.day': 'Department Attendance Person Days',
  'department.total.working.hours': 'Department Total Working Hours',
  'department.average.working.hours': 'Department Average Working Hours',
  'location.city.attendance.person.day': 'Base Location Attendance Person Days',
  'location.city.total.working.hours': 'Base Location Total Working Hours',
  'location.city.average.working.hours': 'Base Location Average Working Hours',
  'review.location': 'Review (Meeting) Location',
  'review.allLocation': 'Location',
  'review.count': 'Review Count',
  'bug.count': 'Bug Count',
  'online.bug.count': 'Online Bug Count',
  'is.have.template': 'Weekly Report Template',
  'dept.status': 'Department Status',
  'total.commit.cnt': 'Total Commit Count',
  'requirment.commit.cnt': 'Requirement Commit Count',
  'bug.commit.cnt': 'Bug Commit Count',
  'online.bug.commit.cnt': 'Online Bug Commit Count',
  'other.commit.cnt': 'Other Commit Count',
  'standard.commit.rate': 'Standard Commit Rate',
  'related.business': 'Related Business Area',
  'related.system': 'Related System',
  'position': 'Position',
  'production.Defects.score': 'Production Defect Score',
  'develop.defects.score': 'Development Defect Score',
  'working.hours.score': 'Working Hours Score',
  'average.score.of.production.and.research': 'Production & Research Average Score',
  'individual.total.score': 'Individual Total Score',
  'technical.debt.score': 'Technical Debt Score',
  'delivery.efficiency.score': 'Delivery Efficiency Score',
  'code.review.report': 'CR Report',
  'status.stage.nameCn': 'Stage Name (Chinese)',
  'status.stage.nameEn': 'Stage Name (English)',
  'status.stage.code': 'Stage Code',
  'status.stage.echoColor': 'Display Color',
  'status.stage.sortNum': 'Sort Number',
  'description': 'Description',
  'workflow': 'Workflow',
  'issue.type': 'Requirement Type',
};
